/* UCHI — Welcome popup behaviour. Preview with ?uwp=preview, or open the theme editor. */
(function () {
  'use strict';

  var STORE_KEY = 'uchi:welcome-popup';
  var KLAVIYO_REVISION = '2026-07-15';
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  var dialog = document.getElementById('uchi-welcome-popup');
  if (!dialog || dialog.dataset.uwpReady) return;
  dialog.dataset.uwpReady = 'true';

  var cfg = {
    companyId: dialog.dataset.companyId,
    listId: dialog.dataset.listId,
    source: dialog.dataset.source || 'Website popup',
    delay: Math.max(0, isNaN(parseInt(dialog.dataset.delay, 10)) ? 10 : parseInt(dialog.dataset.delay, 10)) * 1000,
    suppressDays: parseInt(dialog.dataset.suppressDays, 10) || 7,
    doubleOptIn: dialog.dataset.doubleOptIn === 'true',
    msg: {
      invalid: dialog.dataset.msgInvalid,
      failed: dialog.dataset.msgFailed,
      loading: dialog.dataset.msgLoading,
      copied: dialog.dataset.msgCopied
    }
  };

  var params = new URLSearchParams(window.location.search);
  var preview = params.get('uwp') === 'preview' || !!(window.Shopify && window.Shopify.designMode);

  function readState() {
    try { return JSON.parse(window.localStorage.getItem(STORE_KEY)) || {}; } catch (e) { return {}; }
  }
  function writeState(state) {
    try { window.localStorage.setItem(STORE_KEY, JSON.stringify(state)); } catch (e) {}
    var days = state.status === 'subscribed' ? 3650 : cfg.suppressDays;
    document.cookie = 'uchi_uwp=' + state.status + '; max-age=' + days * 86400 + '; path=/; SameSite=Lax';
  }
  function isSuppressed() {
    var s = readState();
    if (s.status === 'subscribed') return true;
    if (s.status === 'dismissed' && s.until && Date.now() < s.until) return true;
    if (/(?:^|;\s*)uchi_uwp=(subscribed|dismissed)/.test(document.cookie)) return true;
    return false;
  }

  if (params.has('_kx')) writeState({ status: 'subscribed', at: Date.now(), via: 'email-click' });

  function klaviyoIdentified() {
    return new Promise(function (resolve) {
      var k = window.klaviyo;
      if (!k || typeof k.isIdentified !== 'function') return resolve(false);
      var done = false;
      setTimeout(function () { if (!done) { done = true; resolve(false); } }, 1500);
      try {
        k.isIdentified().then(function (v) { if (!done) { done = true; resolve(!!v); } }, function () { if (!done) { done = true; resolve(false); } });
      } catch (e) { done = true; resolve(false); }
    });
  }

  function isVisible(el) {
    if (!el) return false;
    var st = window.getComputedStyle(el);
    if (st.display === 'none' || st.visibility === 'hidden' || parseFloat(st.opacity) === 0) return false;
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0;
  }
  function cookieBannerPending() {
    if (isVisible(document.getElementById('shopify-pc__banner'))) return true;
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    if (cp && typeof cp.shouldShowBanner === 'function' && typeof cp.currentVisitorConsent === 'function') {
      try {
        var c = cp.currentVisitorConsent() || {};
        if (cp.shouldShowBanner() && c.marketing === '' && c.analytics === '') return true;
      } catch (e) {}
    }
    return false;
  }
  function otherModalOpen() {
    var open = document.querySelectorAll('dialog[open], [aria-modal="true"], [role="dialog"], [role="alertdialog"]');
    for (var i = 0; i < open.length; i++) {
      var el = open[i];
      if (el === dialog || dialog.contains(el)) continue;
      if (el.tagName === 'DIALOG' ? el.open && isVisible(el) : isVisible(el)) return true;
    }
    if (isVisible(document.querySelector('.kl-private-reset-css-Xuajs1[role="dialog"], .needsclick[aria-modal="true"]'))) return true;
    if (document.querySelector('header-drawer details[open], .menu-drawer-container[open]')) return true;
    return false;
  }
  function userIsTyping() {
    var a = document.activeElement;
    return a && a !== document.body && /^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName) && !dialog.contains(a);
  }
  function clearToOpen() {
    return !cookieBannerPending() && !otherModalOpen() && !userIsTyping() && document.visibilityState === 'visible';
  }

  var form = dialog.querySelector('[data-uwp-form]');
  var input = dialog.querySelector('[data-uwp-email]');
  var submit = dialog.querySelector('[data-uwp-submit]');
  var submitLabel = dialog.querySelector('[data-uwp-submit-label]');
  var errorEl = dialog.querySelector('[data-uwp-error]');
  var live = dialog.querySelector('[data-uwp-live]');
  var views = {
    form: dialog.querySelector('[data-uwp-view="form"]'),
    success: dialog.querySelector('[data-uwp-view="success"]'),
    confirm: dialog.querySelector('[data-uwp-view="confirm"]')
  };
  var lastFocus = null;
  var submitted = false;

  function open() {
    if (dialog.open) return;
    lastFocus = document.activeElement;
    document.documentElement.classList.add('uwp-lock');
    try { dialog.showModal(); } catch (e) { dialog.setAttribute('open', ''); }
    var coarse = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
    if (coarse) dialog.querySelector('[data-uwp-heading]').focus({ preventScroll: true });
    else input.focus({ preventScroll: true });
    push('uchi_popup_view');
  }

  function close(reason) {
    if (!dialog.open && !dialog.hasAttribute('open')) return;
    if (!submitted) {
      writeState({ status: 'dismissed', until: Date.now() + cfg.suppressDays * 86400000, at: Date.now() });
      push('uchi_popup_dismiss', { uwp_reason: reason });
    }
    try { dialog.close(); } catch (e) { dialog.removeAttribute('open'); }
    document.documentElement.classList.remove('uwp-lock');
    if (lastFocus && typeof lastFocus.focus === 'function' && document.contains(lastFocus)) {
      lastFocus.focus({ preventScroll: true });
    }
  }

  dialog.addEventListener('cancel', function (e) { e.preventDefault(); close('escape'); });
  dialog.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var f = Array.prototype.filter.call(
      dialog.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'),
      function (el) { return el.offsetParent !== null; }
    );
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1], active = document.activeElement;
    if (e.shiftKey && (active === first || !dialog.contains(active) || active.tabIndex === -1)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && (active === last || !dialog.contains(active))) { e.preventDefault(); first.focus(); }
  });
  dialog.addEventListener('click', function (e) {
    if (e.target === dialog) close('backdrop');
  });
  dialog.querySelectorAll('[data-uwp-close]').forEach(function (b) {
    b.addEventListener('click', function () { close(b.dataset.uwpClose || 'close'); });
  });

  function setError(text) {
    errorEl.textContent = text || '';
    if (text) { input.setAttribute('aria-invalid', 'true'); } else { input.removeAttribute('aria-invalid'); }
  }
  function setLoading(on) {
    submit.setAttribute('aria-busy', on ? 'true' : 'false');
    submit.disabled = !!on;
    input.readOnly = !!on;
    if (on) {
      submit.dataset.label = submitLabel.textContent;
      submitLabel.textContent = cfg.msg.loading;
    } else if (submit.dataset.label) {
      submitLabel.textContent = submit.dataset.label;
    }
  }
  function showView(name) {
    Object.keys(views).forEach(function (k) { if (views[k]) views[k].hidden = k !== name; });
    var heading = views[name] && views[name].querySelector('[data-uwp-view-heading]');
    if (heading) heading.focus({ preventScroll: true });
  }

  function subscribe(email) {
    var body = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: cfg.source,
          profile: { data: { type: 'profile', attributes: { email: email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } }
        },
        relationships: { list: { data: { type: 'list', id: cfg.listId } } }
      }
    };
    var ctrl = 'AbortController' in window ? new AbortController() : null;
    var timer = ctrl && setTimeout(function () { ctrl.abort(); }, 12000);
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(cfg.companyId), {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', Accept: 'application/vnd.api+json', revision: KLAVIYO_REVISION },
      body: JSON.stringify(body),
      signal: ctrl ? ctrl.signal : undefined
    }).then(function (res) {
      if (timer) clearTimeout(timer);
      if (res.status >= 200 && res.status < 300) return true;
      return res.text().then(function (t) { throw new Error('Klaviyo ' + res.status + ' ' + t.slice(0, 300)); });
    }, function (err) {
      if (timer) clearTimeout(timer);
      throw err;
    });
  }

  input.addEventListener('input', function () { if (errorEl.textContent) setError(''); });

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (submit.getAttribute('aria-busy') === 'true') return;
    var email = (input.value || '').trim();
    if (!email || !EMAIL_RE.test(email) || (input.validity && input.validity.typeMismatch)) {
      setError(cfg.msg.invalid);
      input.focus();
      return;
    }
    if (!cfg.companyId || !cfg.listId) {
      setError(cfg.msg.failed);
      console.error('[uchi-welcome-popup] Missing Klaviyo company ID or list ID in the section settings.');
      return;
    }
    setError('');
    setLoading(true);
    subscribe(email).then(function () {
      submitted = true;
      writeState({ status: 'subscribed', at: Date.now() });
      setLoading(false);
      identify(email);
      push('uchi_popup_signup');
      if (window.fbq && marketingAllowed()) { try { window.fbq('track', 'Lead'); } catch (e2) {} }
      showView(cfg.doubleOptIn ? 'confirm' : 'success');
    }).catch(function (err) {
      console.error('[uchi-welcome-popup]', err);
      setLoading(false);
      setError(cfg.msg.failed);
      input.focus();
    });
  });

  dialog.querySelectorAll('[data-uwp-copy]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var code = btn.dataset.uwpCopy;
      var label = btn.textContent;
      var ok = function () {
        btn.textContent = cfg.msg.copied;
        live.textContent = cfg.msg.copied;
        setTimeout(function () { btn.textContent = label; live.textContent = ''; }, 2000);
      };
      var el = dialog.querySelector('[data-uwp-code]');
      var sel = window.getSelection();
      var range = document.createRange();
      range.selectNodeContents(el);
      sel.removeAllRanges(); sel.addRange(range);
      var copied = false;
      try { copied = document.execCommand('copy'); } catch (e) {}
      if (copied) { sel.removeAllRanges(); return ok(); }
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(code).then(function () { sel.removeAllRanges(); ok(); }, function () {});
      }
    });
  });

  function marketingAllowed() {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    try { return !!(cp && cp.marketingAllowed && cp.marketingAllowed()); } catch (e) { return false; }
  }
  function identify(email) {
    if (!marketingAllowed() || !window.klaviyo || typeof window.klaviyo.identify !== 'function') return;
    try { window.klaviyo.identify({ email: email }); } catch (e) {}
  }
  function push(event, extra) {
    window.dataLayer = window.dataLayer || [];
    var o = { event: event };
    if (extra) for (var k in extra) o[k] = extra[k];
    window.dataLayer.push(o);
  }

  function schedule() {
    if (!preview && isSuppressed()) return;
    var wait = preview ? 600 : cfg.delay;
    setTimeout(function attempt() {
      if (preview) return open();
      if (isSuppressed()) return;
      if (!clearToOpen()) return void setTimeout(attempt, 1000);
      klaviyoIdentified().then(function (known) {
        if (known) return;
        if (clearToOpen()) open(); else setTimeout(attempt, 1000);
      });
    }, wait);
  }

  window.UchiWelcomePopup = {
    open: open,
    close: function () { close('api'); },
    reset: function () { try { window.localStorage.removeItem(STORE_KEY); } catch (e) {} document.cookie = 'uchi_uwp=; max-age=0; path=/'; }
  };

  if (document.readyState === 'complete') schedule();
  else window.addEventListener('load', schedule, { once: true });
})();
